export default {
  pdmRow1: 'Digital PDM是一种云原生应用程序，能够提升产品研发过程中的业务价值，例如：支持设计过程实时协作，实现信息自动推荐，整条研发过程产生的数据自然构成数字化连，方便实现数据回溯和产品质量问题追溯，同时为产品研发过程中各评审点提供强大准确的决策依据。',
  pdmRow2: '充分利用互联网技术，智能自动化的优势，使应用程序能够根据产品3D特征及2D工程图形状推荐合适的零件，或者即时反馈影响力分析',
  pdmRow3: '快速分析截至当前的设计及制造数据，实现更优决策',
  pdmRow4: '解决性能和扩展相关的遗留问题，同时消除对硬件及数据库的依赖性，轻松部署，实现更新。',
  pdmRow5: '从数据和决策中不断学习，持续提高效率。'
}
